//import RentalLocation from './RentalLocation.js';
export default class Location{
  constructor(){
    this.locationId = '';
    this.locationCity = '';
    this.date = '';
    this.time = '';
  }
}
